import React from 'react';
import { Text, View } from '@react-pdf/renderer';

interface PdfCourseAccordionLabelProps {
	content: React.ReactNode;
	isError?: boolean;
}

const PdfCourseAccordionLabel = (props: PdfCourseAccordionLabelProps) => {
	const {
		content,
		isError = false,
	} = props;

	return (
		<View style={[
			{ padding: 8 },
			isError ? { backgroundColor: '#FAE1E5' } : {},
		]}
		>
			{
				typeof content === 'string' ? (
					<Text>
						{content}
					</Text>
				)
					: content
			}
		</View>
	);
};

export default PdfCourseAccordionLabel;
